document.addEventListener('DOMContentLoaded', function() {
  var interval = setInterval(function() {
    var embed = document.querySelector('shopify-forms-embed');
    if (embed && embed.shadowRoot) {
      clearInterval(interval);
      var style = document.createElement('style');
      style.textContent = `
        /* ===== Box-model reset (fixes the right-edge overflow) ===== */
        ._formContainer_1q1d2_30,
        ._formFieldset_cit2d_82,
        ._formFieldContainer_1mxsl_5,
        ._fieldContainer_exnrn_16,
        ._formPhoneInputContainer_piv1u_6,
        ._multiFieldLine_exnrn_1,
        ._nonMultineFieldLine_exnrn_11,
        ._selectContainer_12thd_6,
        ._selectToggle_12thd_25,
        ._formInputField_nag3b_7,
        ._formPhoneInputField_piv1u_17,
        button[type="submit"] {
          box-sizing: border-box !important;
        }

        ._formContainer_1q1d2_30 {
          max-width: 100% !important;
          width: 100% !important;
        }

        ._formFieldContainer_1mxsl_5,
        ._fieldContainer_exnrn_16,
        ._formPhoneInputContainer_piv1u_6,
        ._formInputField_nag3b_7,
        ._formPhoneInputField_piv1u_17,
        ._selectContainer_12thd_6,
        ._selectToggle_12thd_25 {
          width: 100% !important;
          max-width: 100% !important;
        }

        /* ===== Modern two-column layout ===== */
        ._formFieldset_cit2d_82 {
          display: grid !important;
          grid-template-columns: 1fr 1fr !important;
          gap: 16px 20px !important;
          align-items: start !important;
        }

        /* Elements that should always span both columns */
        ._formFieldset_cit2d_82 > legend,
        ._formFieldset_cit2d_82 > ._multiFieldLine_exnrn_1,
        ._formFieldset_cit2d_82 > ._nonMultineFieldLine_exnrn_11,
        ._formFieldset_cit2d_82 > ._formPhoneInputContainer_piv1u_6,
        ._formFieldset_cit2d_82 > div:has(shop-lead-capture),
        ._formFieldset_cit2d_82 > button[type="submit"] {
          grid-column: 1 / -1 !important;
        }

        /* Inside the multi-field rows (first/last name, zip/city) keep two sub-columns */
        ._multiFieldLine_exnrn_1 {
          display: grid !important;
          grid-template-columns: 1fr 1fr !important;
          gap: 16px !important;
        }
        ._multiFieldLine_exnrn_1 > ._fieldContainer_exnrn_16 {
          min-width: 0 !important; /* lets grid children shrink instead of forcing wrap/overflow */
        }

        /* ===== Visual refresh ===== */
        ._formFieldset_cit2d_82 legend {
          font-size: 14px !important;
          font-weight: 600 !important;
          letter-spacing: 0.02em !important;
          text-transform: uppercase !important;
          color: #6b7280 !important;
          margin: 8px 0 4px !important;
          padding-top: 12px !important;
          border-top: 1px solid #e5e7eb !important;
        }

        ._formInputField_nag3b_7,
        ._formPhoneInputField_piv1u_17 {
          border: 1px solid #d1d5db !important;
          border-radius: 10px !important;
          padding: 18px 12px 6px !important;
          height: 52px !important;
          font-size: 15px !important;
          white-space: nowrap !important;
          text-overflow: ellipsis !important;
          transition: border-color 0.15s ease, box-shadow 0.15s ease !important;
          background: #fff !important;
        }

        ._formInputField_nag3b_7:focus,
        ._formPhoneInputField_piv1u_17:focus {
          border-color: #111827 !important;
          box-shadow: 0 0 0 3px rgba(17,24,39,0.08) !important;
          outline: none !important;
        }

        /* Floating label: ignore the JS-computed inline "top" px and drive position from CSS state instead */
        ._formFieldContainer_1mxsl_5,
        ._formPhoneInputContainer_piv1u_6 > ._formFieldContainer_1mxsl_5 {
          position: relative !important;
        }

        ._formInputFieldLabel_1mxsl_38 {
          position: absolute !important;
          left: 12px !important;
          top: 50% !important;
          transform: translateY(-50%) !important;
          color: #9ca3af !important;
          font-size: 14px !important;
          white-space: nowrap !important;
          overflow: hidden !important;
          max-width: calc(100% - 24px) !important;
          text-overflow: ellipsis !important;
          pointer-events: none !important;
          transition: top 0.12s ease, font-size 0.12s ease !important;
        }

        ._formInputField_nag3b_7:focus + ._formInputFieldLabel_1mxsl_38,
        ._formPhoneInputField_piv1u_17:focus + ._formInputFieldLabel_1mxsl_38,
        ._formInputFieldLabel_1mxsl_38._inputFilled_1mxsl_74 {
          top: 9px !important;
          transform: translateY(0) !important;
          font-size: 11px !important;
          color: #6b7280 !important;
        }

        ._selectToggle_12thd_25 {
          border: 1px solid #d1d5db !important;
          border-radius: 10px !important;
          padding: 10px 12px !important;
          height: 52px !important;
          background: #fff !important;
        }

        button[type="submit"] {
          margin-top: 8px !important;
          font-size: 22px !important;
          border-radius: 10px !important;
          padding: 14px 0 !important;
          font-weight: 600 !important;
          color: #fff !important;
          border: none !important;
          cursor: pointer !important;
          transition: background 0.15s ease !important;
        }
        button[type="submit"]:hover {
          background: #1f2937 !important;
          
        }

        ._formDisclaimer_cit2d_38 {
          grid-column: 1 / -1 !important;
          font-size: 12px !important;
          color: #9ca3af !important;
          margin-top: 8px !important;
        }

        @media (max-width: 768px) {
          ._formFieldset_cit2d_82,
          ._multiFieldLine_exnrn_1 {
            grid-template-columns: 1fr !important;
          }
        }
      `;
      embed.shadowRoot.appendChild(style);
    }
  }, 200);
});